var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHandCoinsCurrency = function SvgHandCoinsCurrency(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M5.997 21.004h-2a1 1 0 0 1-1-1V14a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v6.002a1 1 0 0 1-1 1v0Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 17.002h1.961c.433 0 .855-.14 1.2-.4l2.418-1.813a1.516 1.516 0 0 1 1.98.141v0a1.514 1.514 0 0 1 0 2.143l-2.073 2.074c-.559.559-1.27.94-2.045 1.094l-2.931.587a4 4 0 0 1-1.756-.042l-2.651-.663a3.96 3.96 0 0 0-.97-.12H6.999",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 17.002h1.486a1.515 1.515 0 0 0 1.516-1.515v-.304c0-.695-.473-1.3-1.148-1.47l-2.293-.572a4.707 4.707 0 0 0-1.14-.14v0c-.927 0-1.834.274-2.605.789L6.998 15M19.27 6.73a2.501 2.501 0 1 1-3.537 3.537A2.501 2.501 0 0 1 19.27 6.73",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M6.931 6.045a1.481 1.481 0 0 1 0-2.095l1.52-1.52a1.481 1.481 0 0 1 2.095 0l1.52 1.52a1.481 1.481 0 0 1 0 2.095l-1.52 1.52a1.481 1.481 0 0 1-2.095 0l-1.52-1.52Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgHandCoinsCurrency;